var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangePwIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_58286",
    "data-name": "Group 58286",
    xmlns: "http://www.w3.org/2000/svg",
    width: 10.011,
    height: 13.029,
    viewBox: "0 0 10.011 13.029",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10351",
    "data-name": "Path 10351",
    d: "M146.082,12.468h-.028V11.209a4,4,0,0,0-3.977-4.014,3.921,3.921,0,0,0-3.848,3.912v.12a.33.33,0,0,0,.329.329h1.051a.33.33,0,0,0,.329-.329V11.19A2.258,2.258,0,0,1,142,8.908a2.2,2.2,0,0,1,2.343,2.195v1.361H141.1v0h-3a1.033,1.033,0,0,0-1,1.028v5.695a1.033,1.033,0,0,0,1.032,1.032h7.945a1.033,1.033,0,0,0,1.032-1.032V13.5A1.027,1.027,0,0,0,146.082,12.468ZM142.721,16.6a.222.222,0,0,0-.1.208c0,.417,0,.833,0,1.255h0a.439.439,0,0,1-.236.421.489.489,0,0,1-.732-.421V16.807a.218.218,0,0,0-.093-.2.951.951,0,0,1-.315-1.176.973.973,0,0,1,1.861.384A.882.882,0,0,1,142.721,16.6Z",
    transform: "translate(-137.1 -7.194)",
    fill: "#0075e9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangePwIcon);
export default __webpack_public_path__ + "static/media/change-pw-icon.05e0ada0df365ff5c96325fb116875be.svg";
export { ForwardRef as ReactComponent };